// extracted by mini-css-extract-plugin
module.exports = {"chartWrapper":"RaportDiagrams_chartWrapper__TzKLT"};